import { render, staticRenderFns } from "./BonusRecord.vue?vue&type=template&id=357fb672&scoped=true"
import script from "./BonusRecord.vue?vue&type=script&lang=js"
export * from "./BonusRecord.vue?vue&type=script&lang=js"
import style0 from "./BonusRecord.vue?vue&type=style&index=0&id=357fb672&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357fb672",
  null
  
)

export default component.exports